import React from 'react';
import { Form } from '../../../ui/universe';
import { Select, Tooltip } from 'tdesign-react';

/**
 * Select 参数渲染器
 */
function SelectRenderer({ params, value, disabled, showClose, onClose, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip
              content={<span style={{ whiteSpace: 'pre-line' }}>{params.des}</span>}
              theme="light"
            >
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <div className="flex">
        <div
          style={{
            maxWidth: '100%',
            width: params.width || (params.LabelAlign ? '100%' : undefined)
          }}
        >
          <Select
            status={params.status}
            options={params.options}
            keys={{
              value: 'value',
              label: 'text'
            }}
            placeholder={params.placeholder || '请选择'}
            value={value}
            disabled={disabled}
            onChange={(val) => {
              const extra = params.options[params.options.findIndex((i) => i.value === val)];
              // realValue 支持 false / 0 / '' 等假值，不能使用 || 兜底
              const realVal =
                extra?.realValue !== undefined ? extra.realValue : val;
              onChange && onChange(val, realVal, extra);
            }}
          />
        </div>
        {showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>}
      </div>
    </Form.Item>
  );
}

export default SelectRenderer;
